import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Inbox } from '../Api/Inbox';
import { Toast } from '../hooks/useToast';


export const fetchInboxThunk = createAsyncThunk(
    'inbox/fetch',
    async (_, { getState, dispatch }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await Inbox.fetch({ api_token });
            dispatch(updateIndicator({ is_indicator: false }))
            return response.data
        } catch (err) {
            Toast(err.message, "error", false);
            return Promise.reject(err.message);

        }
    }
)

export const fetchInboxIndicatorThunk = createAsyncThunk(
    'inbox/indicator/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await Inbox.fetchIndicatior({ api_token });
            return response.data
        } catch (err) {
            Toast(err.message, "error", false);
            return Promise.reject(err.message);

        }
    }
)

const initialState = {
    status: "pending",
    data: [],
    inbox: {
        status: 'pending',
        is_indicator: false,
    }
}

export const inboxSlice = createSlice({
    name: 'inbox',
    initialState,
    reducers: {
        resetState: () => {
            return initialState
        },
        updateIndicator: (state, action) => {
            return {
                ...state,
                inbox: {
                    ...state.inbox,
                    ...action.payload
                }
            }
        },
    },
    extraReducers: {
        [fetchInboxThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchInboxThunk.pending]: (state, action) => {
            state.status = "pending"
        },
        [fetchInboxThunk.rejected]: (state, action) => {
            state.status = "rejected"
        },
        [fetchInboxIndicatorThunk.fulfilled]: (state, action) => {
            state.inbox.is_indicator = (state.status === 'success') ? true : action.payload?.is_indicator
            state.inbox.status = 'success'
        },
        [fetchInboxIndicatorThunk.pending]: (state, action) => {
            state.inbox.status = "pending"
        },
        [fetchInboxIndicatorThunk.rejected]: (state, action) => {
            state.inbox.status = "rejected"
        },

    }
})


// Action creators are generated for each case reducer function
export const { resetState, updateIndicator } = inboxSlice.actions

export default inboxSlice.reducer